<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入院校名称" v-model="school_name" @keyup.enter.native="getCollege" class="input-with-select">
        <el-button slot="append" @click="getCollege">
          <img src="@/assets/img/home/search.png" alt="" />
        </el-button>
      </el-input>
    </div>

    <div class="school-item border-1" @click="search(item)" v-for="(item, key) in SchoolList" :key="key">
      <div class="school-logo">
        <el-avatar :size="75" :src="item.logo" />
      </div>
      <div class="school-info">
        <div class="school-name">
          {{ item.name }}
        </div>
        <div class="school-desc">
          <span v-if="item.school_id && item.school_id != '999999'">{{ item.school_id }}</span>
          <span v-if="item.school_belong">/{{ item.school_belong }}</span>
          <span v-if="item.school_nature">/{{ item.school_nature }}</span>
          <span v-if="item.address">/{{ item.address }}</span>
          <span v-if="item.school_type">/{{ item.school_type }}</span>
        </div>
      </div>
      <div class="btn color-1">
        AI分析
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      SchoolList: [],
      userInfo: [],
      school_name: null,
      page: {
        pageNum: 1,
        pageSize: 5,
      },
    };
  },
  computed: {
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('UserInfo'))
    this.getCollege()
  },
  methods: {
    getCollege() {
      // this.loading = true
      let data = {
        name: this.school_name,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        is_wenli: this.userInfo.is_wenli,
        score: this.userInfo.score,
      }

      this.$fecth.post('chat/get_school_list', data).then((res) => {
        this.loading = false
        this.SchoolList = res.lists
      })
    },
    search(e) {
      let data = {
        title: e.name,
        school_name: e.name,
        type: 2
      }
      this.$emit('getChat', data)
    }
  },
};
</script>

<style scoped lang='less'>
.search {
  margin-bottom: 30px
}

.school-item {
  display: flex;
  padding: 15px 15px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  position: relative;
  cursor: pointer;
  margin-bottom: 10px;

  .school-logo {
    width: 90px;
  }

  .school-info {
    flex: 1 1;
  }

  .btn {
    width: 50px;
  }

  .school-name {
    font-size: 18px;
    line-height: 40px;
  }

  .school-desc {
    width: 600px;
    color: #929191;
    line-height: 30px;
  }
}

.school-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
</style>

<style lang="less">
.search_line {
  border-bottom: 1px solid #dfdfdf;
  padding: 10px 0;
}

.search_line:last-child {
  border: 0;
}
</style>
